export default {
  setSiteViewLocal(route) {
    try {
      const userViewSessionCurrentString = localStorage.getItem('userViewSession')
      const userViewSessionCurrent = userViewSessionCurrentString ? JSON.parse(userViewSessionCurrentString) : []
      const FIVE_MINUTE = 5*60*1000; // 5 minutes
      const findRoute = userViewSessionCurrent.find(element => element.routeName === route.name);
      
      if(!findRoute){
        userViewSessionCurrent.push({
          timeAccess: Date.now(),
          routeName: route.name
        })
        localStorage.setItem('userViewSession', JSON.stringify(userViewSessionCurrent))
  
        this.setSiteViewServer(route);
      } else {
        if((Date.now() - findRoute.timeAccess) > FIVE_MINUTE){
          let item = {
            timeAccess: Date.now(),
            routeName: route.name
          }
          let foundIndex = userViewSessionCurrent.findIndex(element => element.routeName === route.name);
          userViewSessionCurrent[foundIndex] = item;
          localStorage.setItem('userViewSession', JSON.stringify(userViewSessionCurrent))
  
          this.setSiteViewServer(route);
        }
      }
    } catch(e) {
      console.log(e)
      console.warn('session count fail!');
    }
  },
  async setSiteViewServer(route) {
    let data = {
      route_name: route.name,
      user_agent: JSON.stringify(navigator.userAgent),
      route_info: JSON.stringify({
        fullPath: route.fullPath,
        meta: route.meta,
        name: route.name,
        path: route.path
      })
    }
    return axios.post(`api/v1/public/set-site-view`, data);
  },
  logging(subject, detail) {
    let data = {
      subject: `[client] ${subject}`,
      detail: detail
    }
    return axios.post(`api/v1/public/front-logging`, data);
  }
}